/**
 * Heatmap application dictionary.
 * Stores all sources of truth regarding data structure and nomenclature.
 */

/** Dependencies -------------------------------------------- */

// External

// Internal

/** Main ---------------------------------------------------- */


/** Getters ------------------------------------------------- */

/**
 * Gets plugin configuration.
 */
export function getPlugin() { return arrayBcPartnershipInteractive }
